class Palette {
  constructor () {
    this.palettes = {
      classic: {
        background: 138,
        player1: 148,
        player2: 106,
        accent: 204
      }
    }
    this.selectedPalette = 'classic'
  }
}

const palette = new Palette()

export function usePalette () {
  return {
    currentPalette () {
      return palette.palettes[palette.selectedPalette]
    },

    selectPalette (nextPalette) {
      palette.selectedPalette = nextPalette
    }
  }
}
